<div class="page-header mb-4">
	<div class="page-header-titles">
		<h5 class="mb-0">{{ title }}</h5>
		<p *ngIf="subtitle" class="mb-0">{{ subtitle }}</p>
	</div>
	<div class="page-header-actions">
		<ng-content select="[headerActions]"></ng-content>
	</div>
</div>
